import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceAppResource from './WorkspaceAppResource';
import UserAppResource from './UserAppResource';

export const CREATED_BY_USER = 'user';
export const CREATED_BY_HJ = 'hj';

export const ALL = {
    CREATED_BY_USER,
    CREATED_BY_HJ,
}

class WorkspacePropertyValuationAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'workspace-property-valuation';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'workspaces/properties/valuations';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'workspaceUuid',
            'userUuid',
            'valuation',
            'createdBy',
            'meta',
            'valuationDate',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            workspace: WorkspaceAppResource,
            user: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            workspace: 'workspace_uuid',
            user: 'user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            workspaceUuid: {
                type: 'string',
                presence: true,
            },
            valuation: {
                numericality: true,
                presence: true,
            },
            createdBy: {
                type: 'string',
                presence: true,
            },
            meta: {},
            valuationDate: {
                datetime: {
                    dateOnly: true
                },
            },
            userUuid: {
                type: 'string',
            },
        };
    }

}

export default WorkspacePropertyValuationAppResource;
